<template>
  <div class="custom-modal" :class="company ? company : ''">
    <div class="container">
      <div class="modal-img">
        <img
          style="width: 60px"
          src="https://chatbotqa.gatblac.com/static/multimedia/iconos/generales/icono-info.png"
        >
      </div>
      <div class="modal-text">
        <p class="center-content">¿Desea cerrar el asistente virtual?</p>
        <label>No podrás abrir nuevamente el asistente virtual</label>
      </div>

      <div class="center-content button-group">
        <button
          type="button"
          class="close-cancel-btn"
          @click="hideModalCloseChatbot"
        >
          No, cancelar
        </button>
        <button
          type="button"
          class="close-delete-btn"
          @click="eventCloseChatbot"
        >
          Si, cerrar
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from './../../main'
export default {
  props: {
    company: { type: String, default: '' }
  },
  methods: {
    hideModalCloseChatbot () {
      serverUI.$emit('modalHideChatbot')
    },
    eventCloseChatbot () {
      serverUI.$emit('modalCloseChatbot')
    }
  }
}
</script>
<style lang="scss">
    .custom-modal {
    color: black;
    font-family: 'Roboto', sans-serif;
  }

  .center-content {
    margin-top: 10px;
    display: flex;
    justify-content: space-evenly;
  }

  .close-cancel-btn, .close-delete-btn {
    width: 35%;
    padding: 15px 0px 15px 0px;
    text-align: center;
  }

  .close-delete-btn {
    color: #1a1a1a;
    border-radius: 25px;
    font-weight: 600;
  }

  .close-cancel-btn {
    border-radius: 25px;
    background-color: transparent;
    border-color: #1a1a1a;
    border-width: 1px;
    border-style: solid;
    font-weight: 600;
  }

  .modal-text p {
    font-size: 18px;
    margin-bottom: 0px;
    font-weight: 600;
  }
  .modal-text label {
    font-size: 12px;
    display: flex;
    justify-content: center;
    color: #96a1af;
  }
  .button-group {
    margin-top: 35px;
  }
  .modal-img {
    margin: 35px 0px 25px 0px;
    display: flex !important;
    justify-content: center;
  }
  .v--modal {
    border-radius: 25px !important;
  }
</style>
